/**
 * File for displaying the attachments panel
 */

import { Button, Col, Drawer, Modal, Row } from 'antd';
import { get, map } from 'lodash';
import React from 'react';
import FontAwesome from '../../components/common/FontAwesome';
import { getIsMobile } from '../../utils/commonFunctions';
import { DynamicObject } from '../../utils/commonInterfaces';

interface IProps {
    readonly visible: boolean;
    readonly closePanel: () => void;
    readonly itemDetails: DynamicObject | null;
    readonly onViewAttachment: (
        isLetter: boolean,
        attachment?: DynamicObject
    ) => void;
}
const NotificationDetailsAttachmentsPanel: React.FC<IProps> = ({
    visible,
    closePanel,
    itemDetails,
    onViewAttachment,
}: IProps) => {
    const isMobile = getIsMobile();
    const panelTitle = 'View attachments';

    const handleClosePanel = () => {
        closePanel();
    };

    const viewAttachment = (attachment: DynamicObject) => {
        onViewAttachment(false, attachment);
    };

    const populatePanelContent = () => {
        const itemLabel = get(itemDetails, 'InvoiceCode')
            ? 'invoice'
            : 'credit';
        return (
            <div>
                <Row>
                    <Col>
                        The following attachments related to {`${itemLabel} `}
                        <b>{get(itemDetails, 'Number')}</b> are available for
                        you to view.
                    </Col>
                </Row>
                <br />
                <Row>
                    {map(
                        get(itemDetails, 'Attachments'),
                        (attachment: DynamicObject) => {
                            return (
                                <Col key={get(attachment, 'FileId')}>
                                    <span className="attachment-icon">
                                        <FontAwesome
                                            className="mr-10 dark-red"
                                            icon={['fas', `file-pdf`]}
                                        />
                                    </span>
                                    <span>{get(attachment, 'Title')}</span>
                                    &emsp;
                                    <span>
                                        <Button
                                            type="link"
                                            onClick={() =>
                                                viewAttachment(attachment)
                                            }
                                        >
                                            View file
                                        </Button>
                                    </span>
                                </Col>
                            );
                        }
                    )}
                </Row>
            </div>
        );
    };

    return (
        <Row>
            <Col>
                {isMobile ? (
                    <div>
                        {visible && (
                            <Modal
                                className="modal-swapped-buttons modal-no-padding"
                                title={panelTitle}
                                visible={visible}
                                onCancel={handleClosePanel}
                                footer={null}
                                style={{ top: 12 }}
                            >
                                <div
                                    style={{
                                        maxHeight: window.innerHeight - 160,
                                        overflowY: 'auto',
                                        padding: 24,
                                    }}
                                >
                                    {populatePanelContent()}
                                </div>
                            </Modal>
                        )}
                    </div>
                ) : (
                    <Drawer
                        title={panelTitle}
                        width={500}
                        onClose={handleClosePanel}
                        visible={visible}
                        className="notification-details-attachments-panel"
                        closable={false}
                        maskClosable={false}
                    >
                        <div>{populatePanelContent()}</div>
                        <br />
                        <Row>
                            <Col className="ta-right" span={24}>
                                <Button onClick={handleClosePanel}>
                                    Close
                                </Button>
                            </Col>
                        </Row>
                    </Drawer>
                )}
            </Col>
        </Row>
    );
};

export default NotificationDetailsAttachmentsPanel;
